/*
 * @fileOverView Search Teams component definition
 */

import Vue from 'vue';
import Search from 'components/modules/utility/search/search.mixin';
import { mapGetters } from 'vuex'
/**
 * [Search Teams Vue]
 * @type {class}
 */
Vue.component('search-teams-vue', {
  mixins: [Search],

  computed: {
    ...mapGetters(['teams/filter']),
      // ...
    filterSearch() {
      if (!this.$store.state["teams"].loaded) {
        this.$store.dispatch('teams/fetch');
      }

      return this['teams/filter'](this.search).map(item => {
        //Don't modify original name
        let name = item.name;

        if (item.team_name) {
          name += ','
        }

        return {
          'name': name,
          'team_name': item.team_name,
          'event_name': item.event_name,
          'url': item.event_url
        }
      }).sort((a, b) => a.term !== b.term ? a.term < b.term ? -1 : 1 : 0);
    }
  },

  methods: {

    /**
     * Handles submission of search form on selection of a term.
     *
     * @method handleSubmit
     * @public
     */
    handleSubmit() {
      //do nothing
    },

    /**
     * Handles selection of an item from a click or keypress.
     *
     * @method handleItemSelected
     * @param {Object} event - Javascript event object
     * @public
     */
    handleItemSelected(e) {
      //Do nothing, these are links
    }
  }
});
